import {
  useId,
  slot,
  isResolvedShorthand,
  useMergedRefs,
} from '@fluentui/react-utilities';
import { Toolbar } from '@fluentui/react-components';
import type * as React from 'react';
import type { ExtractSlotProps, Slot, SlotComponentType } from '@fluentui/react-utilities';

type useActionBarSlotOptions = {
  popoverRef: React.Ref<HTMLDivElement>;
  triggerRef: React.RefObject<HTMLDivElement | null>;
  isFocused: boolean;
  isHovered: boolean;
};

/**
 * @internal
 * @returns  actionBar slot with desired behaviour and props
 */
export function useActionBarSlot(
  actionBarSlotFromProp: Slot<typeof Toolbar> | undefined,
  options: useActionBarSlotOptions,
): SlotComponentType<ExtractSlotProps<Slot<typeof Toolbar>>> | undefined {
  const { popoverRef, isFocused, isHovered } = options;

  const actionBarId = useId(
    'fluentai-actionbar',
    isResolvedShorthand(actionBarSlotFromProp) ? actionBarSlotFromProp.id : undefined,
  );

  const actionBarSlot = slot.optional(actionBarSlotFromProp, {
    elementType: Toolbar,
    defaultProps: {
      id: actionBarId,
      size: 'small',
    },
  });

  /**
   * Clicking on the actionBar should never blur the trigger
   * in a UserMessage
   */


  const actionBarRef = useMergedRefs(actionBarSlot?.ref, popoverRef);
  if (actionBarSlot) {
    actionBarSlot.ref = actionBarRef;
  }

  return isFocused || isHovered ? actionBarSlot : undefined;
}
